import { InjectionToken } from '@angular/core'
import { Database } from '@angular/fire/database'
import { FirebaseLiveStreamService } from './interfaces'

export const FLO_FIREBASE_APP_TOKEN = new InjectionToken<Database>('flo.firebase.app')
export const FLO_FIREBASE_LIVE_STREAM_SERVICE = new InjectionToken<FirebaseLiveStreamService>(
  'flo.firebase.live.stream.service'
)
